import slugify from "@sindresorhus/slugify"

const BLOG_AUDIENCES = {
    OUTFITTERS: "Outfitters",
    SPORTSMEN: "Sportsmen",
    EVERYONE: "Everyone",
}

export const BLOG_PATH_PREFIXES = {
    OUTFITTERS: "/for-guides/blog/",
    SPORTSMEN: "/blog/",
}

export function getPathForBlogEntry(blogEntry: BlogEntryType): string | null {
    const title = blogEntry?.data?.title
    if (!blogEntry || !title) return null

    const isForOutfitter = isBlogEntryForOutfitter(blogEntry)
    const slug = slugify(title, { separator: "-" })

    if (isForOutfitter) {
        return `${BLOG_PATH_PREFIXES.OUTFITTERS}${slug}`
    }
    return `${BLOG_PATH_PREFIXES.SPORTSMEN}${slug}`
}

export function getPathForBlog(isForOutfitter: boolean) {
    if (isForOutfitter) {
        return BLOG_PATH_PREFIXES.OUTFITTERS
    }
    return BLOG_PATH_PREFIXES.SPORTSMEN
}

export function isBlogEntryForOutfitter(blogEntry: BlogEntryType): boolean {
    const audiences = [BLOG_AUDIENCES.OUTFITTERS, BLOG_AUDIENCES.EVERYONE]
    return isBlogEntryForAudiences(blogEntry, audiences)
}

export function isBlogEntryForSportsman(blogEntry: BlogEntryType): boolean {
    const audiences = [BLOG_AUDIENCES.SPORTSMEN, BLOG_AUDIENCES.EVERYONE]
    return isBlogEntryForAudiences(blogEntry, audiences)
}

function isBlogEntryForAudiences(
    blogEntry: BlogEntryType,
    audiences: string[]
): boolean {
    return audiences.includes(blogEntry?.data?.audience)
}

export type BlogEntryType = ArrayElement<
    Queries.builderBlogDataQuery["allBuilderModels"]["blogEntry"]
>

export type BlogEntryAuthorType = ArrayElement<
    Queries.blogEntryAuthorDataQuery["allBuilderModels"]["blogAuthor"]
>
